import { render, staticRenderFns } from "./HistoricoAvisosForm.vue?vue&type=template&id=cc738a62&scoped=true&"
import script from "./HistoricoAvisosForm.vue?vue&type=script&lang=js&"
export * from "./HistoricoAvisosForm.vue?vue&type=script&lang=js&"
import style0 from "./HistoricoAvisosForm.vue?vue&type=style&index=0&id=cc738a62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc738a62",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VCard,VCardText,VCardTitle,VContainer,VExpandTransition,VIcon,VPagination})
